import { formatUnits } from "viem";
import { formatUnitsFixed } from "./formatUnitsFixed";

export const formatBalance = (
  balance: bigint, 
  decimals: number, 
  roundingMode: 'ROUND_HALF_UP' | 'ROUND_DOWN' | 'ROUND_UP' = 'ROUND_DOWN',
  isFiat: boolean = false
): string => {
  const isNegative = balance < 0n;
  const absBalance = isNegative ? -balance : balance;
  let formatted = formatUnits(absBalance, decimals);
  let [integerPart, decimalPart = ''] = formatted.split('.');

  let decimalsToUse = 4;
  if (isFiat || BigInt(integerPart) > 100n) {
    decimalsToUse = 2;
  }

  if (integerPart !== '0') {
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    formatted = formatUnitsFixed(absBalance, decimals, decimalsToUse, roundingMode);
    [, decimalPart = ''] = formatted.split('.');

    if (!isFiat) {
      decimalPart = decimalPart.replace(/0+$/, '');
    }

    const result = decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    return isNegative ? `-${result}` : result;
  }

  if (formatted === '0') {
    return '0';
  }

  decimalsToUse = decimalPart.startsWith('000') ? 6 : 4;
  formatted = formatUnitsFixed(absBalance, decimals, decimalsToUse, roundingMode);
  [, decimalPart = ''] = formatted.split('.');

  if (!isFiat) {
    decimalPart = decimalPart.replace(/0+$/, '');
  }

  return isNegative ? `-0.${decimalPart}` : `0.${decimalPart}`;
}
